import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import DisplayList from "../DisplayList/DisplayList";

import { url } from "../../../../config/config";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import Header from "../../../../Component/NavBar/User/Header/Header";

class GenreBookList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      books: [],
      filterRes: [],
      isEmpty: false,
      cartCount: 0,
    };
  }

  async componentDidMount() {
    if (this.props.match.params.genre !== "All") {
      const response1 = await Axios.get(`${url}/api/books`, {
        params: {
          genre: this.props.match.params.genre,
        },
      });
      if (response1.data.length !== 0) {
        this.setState({
          filterRes: response1.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          filterRes: [],
          isEmpty: true,
        });
      }
    } else {
      const response2 = await Axios.get(`${url}/api/books`);
      if (response2.data.length !== 0) {
        this.setState({
          books: response2.data,
          isEmpty: false,
        });
      } else {
        this.setState({
          books: [],
          isEmpty: true,
        });
      }
    }
  }

  compare = (a, b) => {
    const nameA = a.title.toUpperCase();
    const nameB = b.title.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  };

  getCartCount = async () => {
    const response = await Axios.get(`${url}/api/carts/cartDetails`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    this.setState({
      cartCount: response.data.cart.length,
    });
  };

  render() {
    this.state.books.sort(this.compare);
    this.state.filterRes.sort(this.compare);
    return (
      <div>
        <Header />
        <div>
          {this.props.match.params.genre === "All" ? (
            <DisplayList
              genre={this.props.match.params.genre}
              bookList={this.state.books}
              isEmpty={this.state.isEmpty}
              getCartCount={this.getCartCount}
            />
          ) : (
            <DisplayList
              genre={this.props.match.params.genre}
              bookList={this.state.filterRes}
              isEmpty={this.state.isEmpty}
              getCartCount={this.getCartCount}
            />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(mapStateToProps, null)(GenreBookList);
